var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2193 2.67694L13.1445 -6.10352e-05C9.74071 0.59028 6.78278 1.53935 4.34436 3.6551C2.11914 5.58771 0.837701 7.92322 0 11.1895L2.40054 12.6061C5.10197 8.11605 9.26017 4.59016 14.2193 2.67694Z",
    fill: "#0B5ED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2054 12.6061L45.606 11.1895C44.7683 7.92322 43.4868 5.58771 41.2616 3.6551C38.8232 1.53935 35.8653 0.59028 32.4614 -6.10352e-05L31.3867 2.67694C36.3469 4.58909 40.504 8.11605 43.2054 12.6061Z",
    fill: "#0B5ED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8108 3.77258C11.2237 3.77258 1.79688 13.1556 1.79688 24.6887C1.79688 36.2219 11.2237 45.6049 22.8108 45.6049C34.3979 45.6049 43.8259 36.2219 43.8259 24.6887C43.8259 13.1556 34.3979 3.77258 22.8108 3.77258ZM22.8108 41.4833C13.5074 41.4833 5.93776 33.95 5.93776 24.6898C5.93776 15.4297 13.5074 7.89527 22.8108 7.89527C32.1143 7.89527 39.6839 15.4286 39.6839 24.6898C39.6839 33.9511 32.1143 41.4833 22.8108 41.4833Z",
    fill: "#0B5ED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1917 12.1645L20.7598 23.2086L14.1621 23.4639V26.5169L24.4873 26.9122L23.9115 12.1645H21.1917Z",
    fill: "#0B5ED7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_1179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.606,
    height: 45.606,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.4996b4fb73d83ee7f6f37ea10e8fd4e3.svg";
export { ForwardRef as ReactComponent };